import countryInformationApisClient from '@/services/country-information';

class Regions {
  fetchRegions = async () => {
    const response = await countryInformationApisClient.get(`regions`);
    return response.data;
  };

  fetchCountriesByRegion = async (regionName: string) => {
    const response = await countryInformationApisClient.get(`regions/${regionName}/countries?pageSize=500`);
    return response.data;
  };
}

export const RegionsInstance = new Regions();
